import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from '@gn-audio/jss-components';

type ExtendedFileField = LinkField & {
  value: {
    extension: string;
    src: string;
  };
};
export type DownloadableResourceListItem = {
  id: string;
  headline: Field<string>;
  description: Field<string>;
  headlineGlobal: Field<string>;
  descriptionGlobal: Field<string>;
  file: ExtendedFileField;
  fileDate: Field<string>;
  background?: Field<string>;
};
export type DownloadableResourceListItemProps = {
  item: DownloadableResourceListItem;
};

export type DownloadableResourceListGroup = {
  id: string;
  headline: Field<string>;
  description: Field<string>;
  items: DownloadableResourceListItem[];
  disableAccordion: Field<boolean>;
  collapsedInitially: Field<boolean>;
};
export type DownloadableResourceGroupProps = {
  group: DownloadableResourceListGroup;
};

export type DownloadableResourceList = {
  groups: DownloadableResourceListGroup[];
  showSearchBox?: Field<boolean>;
  background?: Field<string>;
  headline?: Field<string>;
  trackingSpotName?: Field<string>;
};

export type DownloadableResourceListProps = {
  fields: DownloadableResourceList;
} & ComponentProps;
